module.exports = __webpack_public_path__ + "img/LT304493038.7b9505af.png";